/* ----------------------------------------------------------------------------
switch between color themes
---------------------------------------------------------------------------- */
export default class ThemePicker extends HTMLElement {
	static randomOklch() {
		return {
			l: Math.random() * 90 + 10,
			c: Math.random() * 0.122 + 0.01,
			h: Math.random() * 360,
		};
	}

	static accentOklch({ h: textH }, { l: sheetL }) {
		const minDelta = 30;
		const headroomAbove = 100 - sheetL;
		const direction = headroomAbove >= minDelta ? 1 : -1;
		const headroom = direction > 0 ? headroomAbove : sheetL;
		const offset = minDelta + Math.random() * (headroom - minDelta);
		const l = sheetL + direction * offset;
		const h = textH;
		const c = 0.20;
		return { l, c, h };
	}

	static formatOklch({ l, c, h }) {
		return `oklch(${l.toFixed(2)}% ${c.toFixed(2)} ${Math.round(h)})`;
	}

	generateTheme() {
		const text = ThemePicker.randomOklch();
		const sheet = ThemePicker.randomOklch();
		if (Math.abs(text.l - sheet.l) < 40) {
			this.generateTheme();
			return;
		}
		const accent = ThemePicker.accentOklch(text, sheet);

		const textColor = ThemePicker.formatOklch(text);
		const sheetColor = ThemePicker.formatOklch(sheet);
		const accentColor = ThemePicker.formatOklch(accent);

		this.target.style.setProperty('--color-random-text', textColor);
		this.target.style.setProperty('--color-random-sheet', sheetColor);
		this.target.style.setProperty('--color-random-accent', accentColor);
		localStorage.setItem('color-text', textColor);
		localStorage.setItem('color-sheet', sheetColor);
		localStorage.setItem('color-accent', accentColor);
	}

	save(theme) {
		this.target.setAttribute('ui-theme', theme);
		localStorage.setItem('theme', theme);
		this.update(theme);
	}

	update(theme) {
		if (this.querySelector('[aria-current="true"]')) {
			this.querySelector('[aria-current="true"]').removeAttribute(
				'aria-current',
			);
		}
		this.querySelector(`[theme-name="${theme}"]`).setAttribute(
			'aria-current',
			'true',
		);
	}

	selectable() {
		const themeButtons = this.querySelectorAll('[theme-name]');
		for (const element of themeButtons) {
			element.addEventListener('click', (e) => {
				const newTheme = element.getAttribute('theme-name');
				this.save(newTheme);
				if (newTheme === 'random') {
					this.generateTheme();
				}
			});
		}
	}

	connectedCallback() {
		this.target = document.documentElement;
		this.selectable();
		this.update(this.target.getAttribute('ui-theme'));
	}
}

customElements.define('theme-picker', ThemePicker);
